module.exports = __webpack_public_path__ + "img/tooltip_06-vallone-noya-29-white.105bd583.jpg";